import Timer16 from '@carbon/icons-react/es/timer/16';
import { Tooltip } from 'antd';
import React, { FC, useState } from 'react';
import { TaskIdV2 } from 'api/models';
import { Button } from 'components/atoms/button';
import { Maybe } from 'core/maybe';
import { useTranslation } from 'hooks/use-translation';
import { queueMacrotask } from 'utils/macrotask';
import { AddTimeEntryDrawer } from './add-time-entry-drawer';
import { Drawer } from './components';

interface Props {
  taskId: TaskIdV2;
  defaultBillable?: boolean;
  defaultCategory?: Maybe<number>;
}

const focusDurationOnShow = (visible: boolean) => {
  if (!visible) {
    return;
  }
  queueMacrotask(() => {
    const element = document.querySelector('#task_pane_time_entry_duration');

    if (element == null) {
      return;
    }
    (element as HTMLInputElement)?.focus();
  });
};

export const AddTimeEntry: FC<Props> = ({
  taskId,
  defaultBillable,
  defaultCategory,
}) => {
  const [visible, setVisible] = useState(false);

  return (
    <>
      <Tooltip title={useTranslation('task.add_time_entry.tooltip')}>
        <Button
          data-cy="task.add_time_entry"
          type="text"
          size="small"
          icon={<Timer16 />}
          onClick={() => setVisible(true)}
        />
      </Tooltip>
      <Drawer
        visible={visible}
        onClose={() => setVisible(false)}
        afterVisibleChange={focusDurationOnShow}
      >
        <AddTimeEntryDrawer
          defaultBillable={defaultBillable}
          defaultCategory={defaultCategory}
          taskId={taskId}
          onClose={() => setVisible(false)}
        />
      </Drawer>
    </>
  );
};

export { ButtonGroup, Drawer } from './components';
export { DrawerContent } from './drawer-content';
